import { useMemo } from 'react';

import useChartOptions from '@/components/Chart/hooks/options/useChartOptions';
import useSpotOptions from '@/components/Chart/hooks/options/useSpotOptions';
import useChartSeries from '@/components/Chart/hooks/useChartSeries';
import { DATAHUB_DEFAULT_GROUP } from '@/features/DataHub/constants/const';
import { useExportSettings } from '@/features/DataHub/modules/Export/context/ExportSettingsContext';
import { getXAxisRangeStrings } from '@/features/DataHub/utils/getXAxisRangeStrings';
import type { SymbolKey } from '@/entities/symbol';
import type { TemplateChartSeries } from '@/pages/Markets/MarketsComponents/types';

const useSpotChartData = (symbols: SymbolKey[]) => {
  const { exportSettings } = useExportSettings();

  const templateChartSeries: TemplateChartSeries[] = useMemo(() => {
    return Array.from(symbols)
      .slice(0, 6)
      .map(symbol => ({
        settings: { type: 'line' as const },
        symbol: {
          group: DATAHUB_DEFAULT_GROUP,
          key: {
            Code: symbol.Code,
            PeriodType: symbol.PeriodType,
            Period: symbol.Period,
            TimeRef: symbol.TimeRef
          }
        }
      }));
  }, [symbols]);

  const { loading, error, chartSeries } = useChartSeries(templateChartSeries, true);
  const { createOptions } = useSpotOptions();
  const { options: baseOptions } = useChartOptions(chartSeries, createOptions);
  const { xAxisMin, xAxisMax } = getXAxisRangeStrings(exportSettings);

  return { loading, error, chartSeries, baseOptions, xAxisMin, xAxisMax };
};

export default useSpotChartData;
